import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

interface SentryUserParams {
  userId?: string;
  email?: string;
  tenantId?: string;
}

export function useSentryUser({ userId, email, tenantId }: SentryUserParams) {
  useEffect(() => {
    if (userId) {
      Sentry.setUser({ id: userId, email });
      if (tenantId) Sentry.setTag('tenantId', tenantId);
    } else {
      Sentry.setUser(null);
    }
  }, [userId, email, tenantId]);
}
